import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocationDTO } from '../models/LocationDTO';
import { FunctionGpsService } from '../../../../shared/services/ServiceCatalogEncapsulators/FunctionGps.service';
import { LocationsService } from './Locations.service';
@Injectable({
  providedIn: 'root'
})
export class PopupReportHistorialService {
  configUrl: string;
  constructor(private functionsGpsService: FunctionGpsService) {
    this.configUrl = environment.host;
  }

  getReportHist(initialDate: string, finalDate: string, identifier: string = ""): any {
    return this.functionsGpsService.getReportHist(initialDate, finalDate, identifier);
  }

  getReportHabits(initialDate: string, finalDate: string, identifier: string): any {
    return this.functionsGpsService.getReportHabits(initialDate, finalDate, identifier);
  }

  getReportStatistics(initialDate: string, finalDate: string, identifier: string): any {
    return this.functionsGpsService.getReportStatistics(initialDate, finalDate, identifier);
  }

}
